import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import {
  FiMessageCircle,
  FiPhone,
  FiFileText,
  FiUsers,
} from "react-icons/fi";

export default function ActivitiesTab() {
  return (
    <>
      {/* 🔥 INTERNAL CSS */}
      <style>{`
        .activities-card {
          border-radius: 10px;
        }

        .activity-date {
          display: inline-block;
          background: #f3e8ff;
          color: #a855f7;
          font-size: 12px;
          padding: 4px 10px;
          border-radius: 6px;
          margin: 10px 0;
          font-weight: 500;
        }

        .activity-date.upcoming {
          background: #ede9fe;
          color: #7c3aed;
        }

        .activity-item {
          display: flex;
          gap: 12px;
          padding: 12px;
          border: 1px solid #eee;
          border-radius: 8px;
          margin-bottom: 10px;
          align-items: flex-start;
        }

        .activity-icon {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .activity-icon.blue { background: #0ea5e9; }
        .activity-icon.green { background: #22c55e; }
        .activity-icon.yellow { background: #f59e0b; }
        .activity-icon.purple { background: #a855f7; }

        .activity-content h6 {
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 4px;
        }

        .activity-content p {
          margin: 0;
        }

        .activity-time {
          font-size: 12px;
          color: #888;
        }

        .btn-orange-outline {
          border: 1px solid #ff6a00;
          color: #ff6a00;
          background: transparent;
          font-size: 13px;
        }

        .btn-orange-outline:hover {
          background: #ff6a00;
          color: #fff;
        }

        /* 📱 MOBILE */
        @media (max-width: 768px) {
          .activity-content h6 {
            font-size: 13px;
          }

          .activity-time {
            font-size: 11px;
          }

          .btn-orange-outline {
            font-size: 12px;
            padding: 5px 10px;
          }
        }
      `}</style>

      <Card className="activities-card border-0 mt-3">
        
        {/* HEADER */}
        <Card.Header className="d-flex justify-content-between align-items-center flex-wrap gap-2 bg-white border-0">
          <h5 className="mb-0 fw-semibold">Activities</h5>

          <Dropdown>
            <Dropdown.Toggle className="btn-orange-outline">
              Sort By : Last 7 Days
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>Today</Dropdown.Item>
              <Dropdown.Item>Last 7 Days</Dropdown.Item>
              <Dropdown.Item>Last 30 Days</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Card.Header>

        {/* BODY */}
        <Card.Body>

          <div className="activity-date">15 Feb 2024</div>

          <ActivityItem
            icon={<FiMessageCircle />}
            color="blue"
            title="You sent 1 Message to the contact."
            time="10:25 pm"
          />

          <ActivityItem
            icon={<FiPhone />}
            color="green"
            title="Denwar responded to your appointment schedule question by call at 09:30pm."
            time="09:25 pm"
          />

          <ActivityItem
            icon={<FiFileText />}
            color="yellow"
            title="Notes added by Antony"
            description="Please accept my apologies for the inconvenience caused. It would be much appreciated if it's possible to reschedule to 6:00 PM."
            time="10:00 pm"
          />

          <div className="activity-date">15 Feb 2024</div>

          <ActivityItem
            icon={<FiUsers />}
            color="purple"
            title="Meeting With Abraham"
            description="Scheduled on 05:00 pm"
          />

          <ActivityItem
            icon={<FiPhone />}
            color="green"
            title="Drain responded to your appointment schedule question."
            time="09:25 pm"
          />

          <div className="activity-date upcoming">Upcoming Activity</div>

          <ActivityItem
            icon={<FiUsers />}
            color="purple"
            title="Product Meeting"
            description="A product team meeting is a gathering of the cross-functional product team."
          />

        </Card.Body>
      </Card>
    </>
  );
}


/* 🔹 ITEM COMPONENT */
function ActivityItem({ icon, color, title, description, time }) {
  return (
    <div className="activity-item">
      <div className={`activity-icon ${color}`}>
        {icon}
      </div>

      <div className="activity-content">
        <h6>{title}</h6>

        {description && (
          <p className="text-muted small">{description}</p>
        )}

        {time && (
          <span className="activity-time">{time}</span>
        )}
      </div>
    </div>
  );
}